<div
  #trigger="cdkOverlayOrigin"
  (mouseleave)="isOpen = !isOpen"
  (mouseenter)="isOpen = !isOpen"
  cdkOverlayOrigin
  class="mx-2 text-muted"
  fxLayout="flex"
>
  {{ members?.length }} <mat-icon>group</mat-icon>
</div>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
>
  <mat-card class="card-members" [dir]="dir">
    <small *ngFor="let member of members; first as first">
      <span *ngIf="!first"> - </span>
      {{ member.reviewer | getMemberName }}
    </small>
  </mat-card>
</ng-template>
